module.exports = __webpack_public_path__ + "~@/assets/img/bg-bottom.57750a87.svg";